let timer = 0;

function set_interval() {
    timer = setInterval("auto_reload()", 60000);
}

function reset_interval() {
    if (timer != 0) {
        clearInterval(timer);
        timer = 0;
        timer = setInterval("auto_reload()", 60000);
    }
}

function auto_reload() {
    location.reload();
}

function showToppings(currentCategory) {
    $('.body-addition-card__item').each(function () {
        if ($(this).attr('data-category') == currentCategory) {
            $(this).removeClass('hide_topping');
        } else {
            $(this).addClass('hide_topping');
        }
    });
}

function count_cart_items() {
    $.ajax({
        type: 'GET',
        url: '/count_cart_items',
        success: function (response) {
            $('.cart-main-header__count').text(response);
            $('.head-main-cart__counts').text(response + ' ' + productsPlaceholder);
            $('.mobile-cart__counts').text(response);
        }
    });
}

function get_delivery_prices() {
    $.ajax({
        type: 'GET',
        url: '/get_delivery_prices',
        success: function (response) {
            if ($('.cities_option').length > 0 && $('input[name="address-delivery"]').eq(0).is(':checked')) {
                $('._delivery').find('.list-sidebar-cart__value').text(JSON.parse(response).deliveryPriceLimit.replace(',', '.') + ' mdl');
                $('._delivery_value').find('.list-sidebar-cart__value').text(JSON.parse(response).deliveryPrice.replace(',', '.') + ' mdl');
                ajaxDeliveryLimit = JSON.parse(response).deliveryPriceLimit;
                ajaxDelivery = JSON.parse(response).deliveryPrice;
            } else {
                ajaxDeliveryLimit = '0,00';
                ajaxDelivery = '0,00';
            }

            calculate_cart_items_page();
        }
    })

}

function calculate_cart_items_page() {
    let total = 0;
    let priceLimit = $('._delivery_value').find('.list-sidebar-cart__value').text();
    let remainP = $('._delivery').find('.list-sidebar-cart__value').text();

    if ($('.body-products-main-cart__item').length != 0) {
        $('.body-products-main-cart__total-price').each(function () {
            total = total + (parseFloat($(this).text().replace(' mdl', '')));
        });

        if (typeof ajaxDeliveryLimit !== 'undefined' && total < parseFloat(ajaxDeliveryLimit.replace(' mdl', ''))) {
            let progressBarPercent = (ajaxDeliveryLimit / 100);
            remainP = ajaxDeliveryLimit - total;
            let remainPercent = total / progressBarPercent;

            remainP = remainP.toLocaleString('en-GB', {
                minimumFractionDigits: 2
            });

            let sum = parseFloat(total) + parseFloat(ajaxDelivery);

            sum = sum.toLocaleString('en-GB', {
                minimumFractionDigits: 2
            });

            total = total.toLocaleString('en-GB', {
                minimumFractionDigits: 2
            });

            $('.head-address-form-main-cart__price').first().text(ajaxDelivery.replace(',', '.') + ' mdl');

            $('._delivery').find('.list-sidebar-cart__value').text(remainP.replace(',', '.') + ' mdl');
            $('._delivery_value').find('.list-sidebar-cart__value').text(ajaxDelivery.replace(',', '.') + ' mdl');
            $('.list-sidebar-cart__line').css('width', remainPercent + '%');
            $('._subtotal').find('.list-sidebar-cart__value').text(total.replace(',', '.') + ' mdl');
            $('._total').find('.list-sidebar-cart__value').text(sum.replace(',', '.') + ' mdl');
        } else if (typeof ajaxDelivery !== 'undefined') {
            total = total.toLocaleString('en-GB', {
                minimumFractionDigits: 2
            });

            $('.head-address-form-main-cart__price').first().text('0 mdl');

            $('._delivery').find('.list-sidebar-cart__value').text('0 mdl');
            $('._delivery_value').find('.list-sidebar-cart__value').text('0 mdl');
            $('.list-sidebar-cart__line').css('width', '100%');
            $('._subtotal').find('.list-sidebar-cart__value').text(total.replace(',', '.') + ' mdl');
            $('._total').find('.list-sidebar-cart__value').text(total.replace(',', '.') + ' mdl');
        }
    } else {
        if (typeof ajaxDeliveryLimit !== 'undefined' && ajaxDeliveryLimit == 'textpage') {
            ajaxDeliveryLimit = ajaxDeliveryLimit.toLocaleString('en-GB', {
                minimumFractionDigits: 2
            });

            $('.head-address-form-main-cart__price').first().text(ajaxDelivery.replace(',', '.') + ' mdl');

            $('._delivery').find('.list-sidebar-cart__value').text(ajaxDeliveryLimit.replace(',', '.') + ' mdl');
            $('.list-sidebar-cart__line').css('width', '0%');
            $('._subtotal').find('.list-sidebar-cart__value').text('0 mdl');
            $('._total').find('.list-sidebar-cart__value').text('0 mdl');
        }
    }
}

function delete_from_cart(item) {
    $.ajax({
        type: 'POST',
        url: '/delete_from_cart',
        data: {
            'productId': item.attr('data-key')
        },
        success: function () {
            $(item).parent().parent().remove();
        }
    }).done(function () {
        count_cart_items_placeholder();
        update_cart();
        calculate_cart_items_page();
        count_cart_items();
    });
}

function update_product_amount(productKey, amount) {
    $.ajax({
        type: 'POST',
        url: '/update_product_amount',
        data: {
            productKey: productKey,
            amount: amount
        },
        success: function () {
            count_cart_items();
        }
    });
}

function update_header_cart() {
    let total = 0;

    if ($('.products-cart-main-header__item').length != 0) {
        $('.products-cart-main-header__price').each(function () {
            total = total + (parseFloat($(this).text().replace(' mdl', '')) * $(this).prev().find('.quantity').find('.quantity__input_cart').find('input').val());
        });

        if (total < parseFloat(deliveryPriceLimit.replace(' ', ''))) {
            let progressBarPercent = (deliveryPriceLimit / 100);
            let remainPrice = deliveryPriceLimit - total;
            let remainPercent = total / progressBarPercent;

            remainPrice = remainPrice.toLocaleString(undefined, {
                minimumFractionDigits: 2
            });

            let sum = parseFloat(total) + parseFloat(deliveryPrice);

            sum = sum.toLocaleString(undefined, {
                minimumFractionDigits: 2
            });

            total = total.toLocaleString(undefined, {
                minimumFractionDigits: 2
            });

            $('._delivery_header').find('.list-cart-main-header__value').text(remainPrice + ' mdl');
            $('._delivery_value_header').find('.list-cart-main-header__value').text(deliveryPrice + ' mdl');
            $('.list-cart-main-header__progress').css('width', remainPercent + '%');
            $('._subtotal_header').find('.list-cart-main-header__value').text(total + ' mdl');
            $('._total_header').find('.list-cart-main-header__value').text(sum + ' mdl');
        } else {
            total = total.toLocaleString(undefined, {
                minimumFractionDigits: 2
            });

            $('._delivery_header').find('.list-cart-main-header__value').text('0 mdl');
            $('._delivery_value_header').find('.list-cart-main-header__value').text('0 mdl');
            $('.list-cart-main-header__progress').css('width', '100%');
            $('._subtotal_header').find('.list-cart-main-header__value').text(total + ' mdl');
            $('._total_header').find('.list-cart-main-header__value').text(total + ' mdl');
        }
    } else {
        deliveryPriceLimit = deliveryPriceLimit.toLocaleString(undefined, {
            minimumFractionDigits: 2
        });
        $('._delivery_header').find('.list-cart-main-header__value').text('0 mdl');
        $('._delivery_value_header').find('.list-cart-main-header__value').text(deliveryPrice + ' mdl');
        $('.list-cart-main-header__progress').css('width', '100%');
        $('._subtotal_header').find('.list-cart-main-header__value').text('0 mdl');
        $('._total_header').find('.list-cart-main-header__value').text('0 mdl');
    }
}

function update_cart() {
    $.ajax({
        type: 'GET',
        url: '/update_cart',
        data: {
            lang: $('.language-main-header__item._active').attr('data-lang')
        },
        success: function (response) {
            if (response != '') {
                $('.cart-main-header__content').remove();
                $('.cart-main-header__icon').after(JSON.parse(response));

                let total = 0;

                if ($('.products-cart-main-header__item').length != 0) {
                    $('.products-cart-main-header__price').each(function () {
                        total = total + (parseFloat($(this).text().replace(' mdl', '')) * $(this).prev().find('.quantity__input_cart').find('input').val());
                    });

                    if (typeof ajaxDeliveryLimit !== 'undefined' && total < parseFloat(ajaxDeliveryLimit.replace(' mdl', ''))) {
                        let progressBarPercent = (ajaxDeliveryLimit / 100);
                        let remainPrice = ajaxDeliveryLimit - total;
                        let remainPercent = total / progressBarPercent;

                        remainPrice = remainPrice.toLocaleString(undefined, {
                            minimumFractionDigits: 2
                        });

                        let sum = parseFloat(total) + parseFloat(ajaxDelivery);

                        sum = sum.toLocaleString(undefined, {
                            minimumFractionDigits: 2
                        });

                        total = total.toLocaleString(undefined, {
                            minimumFractionDigits: 2
                        });

                        $('._delivery_header').find('.list-cart-main-header__value').text(remainPrice + ' mdl');
                        $('._delivery_value_header').find('.list-cart-main-header__value').text(ajaxDelivery + ' mdl');
                        $('.list-cart-main-header__progress').css('width', remainPercent + '%');
                        $('._subtotal_header').find('.list-cart-main-header__value').text(total + ' mdl');
                        $('._total_header').find('.list-cart-main-header__value').text(sum + ' mdl');
                    } else if (typeof ajaxDelivery !== 'undefined') {
                        total = total.toLocaleString(undefined, {
                            minimumFractionDigits: 2
                        });

                        $('._delivery_header').find('.list-cart-main-header__value').text('0 mdl');
                        $('._delivery_value_header').find('.list-cart-main-header__value').text('0 mdl');
                        $('.list-cart-main-header__progress').css('width', '100%');
                        $('._subtotal_header').find('.list-cart-main-header__value').text(total + ' mdl');
                        $('._total_header').find('.list-cart-main-header__value').text(total + ' mdl');
                    }
                } else {
                    if (typeof ajaxDeliveryLimit !== 'undefined' && ajaxDeliveryLimit == 'textpage') {
                        ajaxDeliveryLimit = ajaxDeliveryLimit.toLocaleString('en-GB', {
                            minimumFractionDigits: 2
                        });

                        $('._delivery_header').find('.list-cart-main-header__value').text('0 mdl');
                        $('._delivery_value_header').find('.list-cart-main-header__value').text(ajaxDeliveryLimit + ' mdl');
                        $('.list-cart-main-header__progress').css('width', '100%');
                        $('._subtotal_header').find('.list-cart-main-header__value').text('0 mdl');
                        $('._total_header').find('.list-cart-main-header__value').text('0 mdl');
                    }
                }
            }

            return false;
        }
    });
}

function count_cart_items_placeholder() {
    $.ajax({
        type: 'GET',
        url: '/count_cart_items',
        success: function (response) {
            $('.head-main-cart__counts').text('');
            $('.head-main-cart__counts').text(response + ' ' + productsPlaceholder);
        }
    });
}

$(window).on('load', function () {
    $('.loader').fadeOut('slow');
    setTimeout(function () {
        $('.wrapper').removeClass('hide-wrapper');
    }, 0);
});

$(document).mousemove(function () {
    reset_interval();
});

$(document).on('click', function () {
    reset_interval();
});

$(document).on('keypress', function () {
    reset_interval();
});

$(document).scroll(function () {
    reset_interval();
});

function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

$(document).ready(function () {
    let ajaxDeliveryLimit = 0,
        ajaxDelivery = 0;

    if ($('.cart').length) {
        setInterval(function () {
            $.ajax({
                type: 'GET',
                url: '/check_global_serving_time',
                success: function (response) {
                    if (response != '<pre>1</pre>') {
                        $('.sidebar-cart__other').attr('disabled', 'disabled');
                        $('.sidebar-cart__other').css('display', 'none');
                    } else {
                        $('.sidebar-cart__other').removeAttr('disabled');
                        $('.sidebar-cart__other').removeAttr('style');
                    }
                }
            });
        }, 100);
    }

    if ($('.alcool').length > 0) {
        if (!localStorage.getItem('18_years')) {
            $('.page').css('pointer-events', 'none');
        }

        if (localStorage.getItem('18_years')) {
            $('.popup_18').css('display', 'none');
        } else {
            $('.popup_18').removeAttr('style');
        }

        $(document).on('click', '#popup_18_yes_button', function () {
            localStorage.setItem('18_years', true);
            $('.popup_18').css('display', 'none');
            $('.page').removeAttr('style');
        });

        $(document).on('click', '#popup_18_no_button', function () {
            localStorage.removeItem('18_years');
            let currentLanguage = $('.language-main-header__item._active').attr('data-lang');
            window.location.href = '/' + currentLanguage;
        });
    }

    get_delivery_prices();

    $('#mobile-cart').on('click', function () {
        window.location.href = $('.cart-main-header__btn').attr('href');
    });

    let currentDate = new Date();

    $(document).on('change', 'input[name="date"], input[name="data"]', function (event) {
        event.preventDefault();

        let currentDateFormated = currentDate.getFullYear() + '-' + String(currentDate.getMonth() + 1).padStart(2, '0') + '-' + String(currentDate.getDate()).padStart(2, '0');

        if ($(this).val() == currentDateFormated) {
            $(this).val('');
            return false;
        }

        if ($(this).val() && $(this).val() != '') {
            if ($(this).val() < currentDateFormated) {
                alert(chooseLaterDate);
                $(this).val('');
                return false;
            }
        }
    });

    $(".datepicker_banquet").datepicker({
        dateFormat: 'yy-mm-dd',
        minDate: '2023/05/25',
        maxDate: 0,
        changeYear: true
    }).attr('readonly', 'readonly');

    $(".datepicker_banquet").datepicker("setDate", currentDate);

    if (screen.width <= 900) {
        $(document).on('click', '.cart-main-header', function (event) {
            event.preventDefault();
            window.location.href = $('.cart-main-header__btn').attr('href');
            return false;
        });
    }

    $(document).on('click', '.spoiler-button', function () {
        if ($('.spoiler-content').is(':visible')) {
            $('.spoiler-content').css('display', 'none');
        } else {
            $('.spoiler-content').css('display', 'block');
        }
    });

    if ($('.personal_data').length) {

        $(document).on('click', '.save_personal', function (event) {
            event.preventDefault();

            $.ajax({
                type: 'POST',
                url: window.location.href,
                data: {
                    name_surname: $('input[name="name_surname"]').val(),
                    email: $('input[name="email"]').val(),
                    interphone: $('input[name="interphone"]').val(),
                },
                success: function (response) {
                    if (JSON.parse(response).success) {
                        toastr.success(JSON.parse(response).success);
                    } else {
                        toastr.error(JSON.parse(response).error);
                    }
                }
            });
        });

        $(document).on('click', '.change_password', function (event) {
            event.preventDefault();

            if ($('input[name="password"]').val() == '' || $('input[name="password-new"]').val() == '' || $('input[name="password-new-repeat"]').val() == '') {
                toastr.error(fillNecesaryInfo);
                return false;
            }

            if ($('input[name="password-new"]').val() != $('input[name="password-new-repeat"]').val()) {
                toastr.error(passwordsDontMatch);
                return false;
            }

            $.ajax({
                type: 'POST',
                url: window.location.href,
                data: {
                    old_password: $('input[name="password"]').val(),
                    password: $('input[name="password-new"]').val()
                },
                success: function (response) {
                    if (JSON.parse(response).success) {
                        toastr.success(JSON.parse(response).success);
                    } else {
                        toastr.error(JSON.parse(response).error);
                    }
                }
            });
        });
    }

    if ($('.register_button').length) {

        set_interval();

        grecaptcha.ready(() => {
            grecaptcha.execute('6LfPmtYiAAAAACJofbUnJQGP7YnVi5Cc1JWIaAgB', {
                action: 'contact'
            }).then(token => {
                $(document).on('click', '.register_button', function (event) {
                    event.preventDefault();

                    if ($('input[name="register_email"]').val() == '' || $('input[name="register_password"]').val() == '' || $('input[name="register_repeat_password"]').val() == '') {
                        toastr.error(fillNecesaryInfo);
                        return false;
                    }

                    if ($('input[name="register_password"]').val() != $('input[name="register_repeat_password"]').val()) {
                        toastr.error(passwordsDontMatch);
                        return false;
                    }

                    if (!$('input[name="terms_checkbox"]').is(':checked')) {
                        toastr.error(acceptTermsAndConditions);
                        return false;
                    }

                    $.ajax({
                        type: 'POST',
                        url: '/register-user?token=' + token,
                        data: {
                            name_surname: $('input[name="register_name"]').val(),
                            email: $('input[name="register_email"]').val(),
                            register_password: $('input[name="register_password"]').val(),
                            register_repeat_password: $('input[name="register_repeat_password"]').val(),
                        },
                        success: function (response) {
                            if (isJson(response) && JSON.parse(response) == "error") {
                                localStorage.setItem('already_registered', 1);
                                location.reload();
                                return false;
                            }

                            localStorage.setItem('register_success', 1);
                            location.reload();
                        },
                        error: function (response) {
                            localStorage.setItem('register_error', 1);
                            location.reload();
                        }
                    });
                });
            });
        });
    }

    if ($('.feedback').length) {
        $(document).on('click', '.form-feedback__btn', function () {
            if (!$('input[name="terms_checkbox"]').is(':checked')) {
                toastr.error(acceptTermsAndConditions);
                return false;
            }

            if ($('input[name="name"]').val() == '' || $('input[name="email"]').val() == '') {
                toastr.error(fillNecesaryInfo);
                return false;
            }

            $.ajax({
                type: 'POST',
                url: window.location.href,
                data: {
                    name: $('input[name="name"]').val(),
                    email: $('input[name="email"]').val(),
                    message: $('textarea[name="messages"]').val()
                },
                success: function () {
                    location.reload();
                }
            });
        });
    }

    if ($('.gallery').length) {
        if ($('.gallery__item').length > 4) {
            $('.gallery__more').removeAttr('style');
        } else {
            $('.gallery__more').css('display', 'none');
        }

        $(document).on('click', '.gallery__more', function () {
            $('.hidden_gallery_item').each(function () {
                $(this).removeClass('hidden_gallery_item');
                $('.gallery__more').css('display', 'none');
            });
        });
    }

    if ($('.cake').length) {

        set_interval();

        let currentFormAction = $('.cake__form').attr('action');

        grecaptcha.ready(() => {
            grecaptcha.execute('6LfPmtYiAAAAACJofbUnJQGP7YnVi5Cc1JWIaAgB', {
                action: 'contact'
            }).then(token => {
                $('.cake__form').attr('action', currentFormAction + '?token=' + token);
            });
        });

        $('input[name="category"]').first().trigger('click');
        $('input[name="levels"]').first().trigger('click');
        $('input[name="decor"]').first().trigger('click');
        $('input[name="filling"]').first().trigger('click');

        if ($('#map').length) {
            // ymaps.ready(init);

            // function init() {
            //     myMap = new ymaps.Map('map', {
            //         center: [47.024512, 28.832157],
            //         zoom: 16
            //     }, {
            //         searchControlProvider: 'yandex#search'
            //     });
            // }
        }

        $('.file-cake__file').on('change', function (event) {
            if (event.target.files[0]) {
                $('#cake-output').attr('src', window.URL.createObjectURL(event.target.files[0]));
                $('#cake-output').removeAttr('style');
            } else {
                $('#cake-output').css('display', 'none');
            }
        });

        $(document).on('click', '.select__option', function () {
            $.ajax({
                type: 'GET',
                url: '/get_shop_data',
                data: {
                    shopId: $(this).attr('data-value'),
                    lang: $('.language-main-header__item._active').attr('data-lang')
                },
                success: function (response) {
                    let shop = JSON.parse(response).shop;

                    $('.info-store-address-form-main-cart__name').text(shop.title);
                    $('.info-store-address-form-main-cart__address').text(shop.address);
                    $('.info-store-address-form-main-cart__time').text(shop.work_start + '-' + shop.work_end);
                    $('.info-store-address-form-main-cart__phone').text(shop.phone);
                    $('.info-store-address-form-main-cart__phone').attr('href', 'tel:' + shop.phone);

                    pickName = $('.info-store-address-form-main-cart__body').find('.info-store-address-form-main-cart__name').text();
                    pickAddress = $('.info-store-address-form-main-cart__body').find('.info-store-address-form-main-cart__address').text();
                    pickTime = $('.info-store-address-form-main-cart__body').find('.info-store-address-form-main-cart__time').text();
                    pickPhone = $('.info-store-address-form-main-cart__body').find('.info-store-address-form-main-cart__phone').text();

                    deliveryStreet = '';
                    block = '';
                    apartment = '';
                    scara = '';
                    floor = '';
                    interphone = '';

                    if (shop.lat != '' && shop.lat != null && shop.lng != '' && shop.lng != null) {
                        myMap.destroy();
                        myMap = null;

                        myMap = new ymaps.Map('map', {
                                center: [parseFloat(shop.lat), parseFloat(shop.lng)],
                                zoom: 17
                            }, {
                                searchControlProvider: 'yandex#search'
                            }),

                            MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
                                '<div style="color: #FFFFFF; font-weight: bold;">$[properties.iconContent]</div>'
                            ),

                            myPlacemark = new ymaps.Placemark(myMap.getCenter(), {
                                hintContent: ''
                            }, {
                                iconLayout: 'default#image',
                                iconImageSize: [38, 42],
                                iconImageOffset: [-5, -38]
                            });

                        myMap.geoObjects.add(myPlacemark);
                    }
                }
            });
        });

        $('input[name="address-delivery"]').on('click', function () {
            let deliveryType = $(this).val();
            $.ajax({
                type: 'POST',
                url: '/change_delivery_price',
                data: {
                    delivery_type: deliveryType
                },
                success: function () {
                    if (deliveryType == '2') {
                        pickName = $('.info-store-address-form-main-cart__body').find('.info-store-address-form-main-cart__name').text();
                        pickAddress = $('.info-store-address-form-main-cart__body').find('.info-store-address-form-main-cart__address').text();
                        pickTime = $('.info-store-address-form-main-cart__body').find('.info-store-address-form-main-cart__time').text();
                        pickPhone = $('.info-store-address-form-main-cart__body').find('.info-store-address-form-main-cart__phone').text();

                        deliveryStreet = '';
                        block = '';
                        apartment = '';
                        scara = '';
                        floor = '';
                        interphone = '';
                    } else {
                        pickName = '';
                        pickAddress = '';
                        pickTime = '';
                        pickPhone = '';
                    }
                }
            });

            if (deliveryType == '2') {
                $('.select__shops').each(function (index) {
                    if (index == '0') {
                        $(this).trigger('click');
                    }
                });
            }
        });

        $('.cake__form').submit(function (event) {
            $('input[name="cake-kg"]').val($('.noUi-handle').attr('aria-valuetext'));

            $('input[name="address-delivery"]').each(function (index) {
                if (index == '0' && $(this).is(':checked')) {
                    if ($('input[name="address"]').val() == '' || $('input[name="block"]').val() == '') {
                        event.preventDefault();
                        toastr.error(fillNecesaryInfo);
                        return false;
                    }
                }
            });

            if ($('#cake-output').attr('src') == '') {
                event.preventDefault();
                toastr.error(fillNecesaryInfo);
                return false;
            }

            if ($('input[name="data"]').val() == '') {
                event.preventDefault();
                toastr.error(fillNecesaryInfo);
                return false;
            }

            if ($('input[name="time"]').val() == '') {
                event.preventDefault();
                toastr.error(fillNecesaryInfo);
                return false;
            }

            if ($('input[name="name"]').val() == '') {
                event.preventDefault();
                toastr.error(fillNecesaryInfo);
                return false;
            }

            if ($('input[name="phone"]').val() == '') {
                event.preventDefault();
                toastr.error(fillNecesaryInfo);
                return false;
            }

            if (!$('input[name="terms_checkbox"]').is(':checked')) {
                event.preventDefault();
                toastr.error(acceptTermsAndConditions);
                return false;
            }
        });
    }

    if ($('.banquet').length) {

        set_interval();

        let banquetFormAction = $('.banquet_form').attr('action');

        grecaptcha.ready(() => {
            grecaptcha.execute('6LfPmtYiAAAAACJofbUnJQGP7YnVi5Cc1JWIaAgB', {
                action: 'contact'
            }).then(token => {
                $('.banquet_form').attr('action', banquetFormAction + '?token=' + token);
            });
        });

        $('.banquet_form').submit(function (event) {
            if (!$('input[name="terms_checkbox"]').is(':checked')) {
                event.preventDefault();
                toastr.error(acceptTermsAndConditions);
                return false;
            }
        });
    }

    update_cart();

    $('.address-main-account__btn').on('click', function (event) {
        event.preventDefault();

        if ($('input[name="address"]').val() == '' || $('input[name="block"]').val() == '') {
            toastr.error(fillNecesaryInfo);
            return false;
        }

        $.ajax({
            type: 'POST',
            url: window.location.href,
            data: {
                address: $('input[name="address"]').val(),
                block: $('input[name="block"]').val(),
                apartment: $('input[name="apartment"]').val(),
                entrance: $('input[name="entrance"]').val(),
                floor: $('input[name="floor"]').val(),
                interphone: $('input[name="interphone"]').val(),
            },
            success: function (response) {
                response = JSON.parse(response);

                if (response.success) {
                    toastr.success(response.success);
                } else {
                    toastr.error(response.success);
                }
            }
        });
    });

    if ($('.order-confirm').length) {
        $('.cart-main-header').css('pointer-events', 'none');
    }

    let fullAddress = '';
    let paymentMethod = '';
    let fullName = '';
    let phone = '';

    let deliveryStreet = '',
        block = '',
        apartment = '',
        scara = '',
        floor = '',
        interphone = '';

    let pickName = '',
        pickAddress = '',
        pickTime = '',
        pickPhone = '';

    $('input[name="name"]').on('keydown', function () {
        fullName = $(this).val();
    });

    $('input[name="phone"]').on('keydown', function () {
        phone = $(this).val();
    });

    $('input[name="street"]').on('keydown', function () {
        deliveryStreet = $(this).val();
    });

    deliveryStreet = $('input[name="street"]').val();

    $('input[name="block"]').on('keydown', function () {
        block = $(this).val();
    });

    block = $('input[name="block"]').val();

    $('input[name="apartament"]').on('keydown', function () {
        apartment = $(this).val();
    });

    apartment = $('input[name="apartament"]').val();

    $('input[name="scara"]').on('keydown', function () {
        scara = $(this).val();
    });

    scara = $('input[name="scara"]').val();

    $('input[name="floor"]').on('keydown', function () {
        floor = $(this).val();
    });

    floor = $('input[name="floor"]').val();

    $('input[name="interphone"]').on('keydown', function () {
        interphone = $(this).val();
    });

    interphone = $('input[name="interphone"]').val();

    if ($('.order-info').length) {

        if ($('#recaptchaResponse').length && !$('.order-confirm').length) {
            grecaptcha.ready(() => {
                grecaptcha.execute('6LfPmtYiAAAAACJofbUnJQGP7YnVi5Cc1JWIaAgB', {
                    action: 'contact'
                }).then(token => {
                    $('#recaptchaResponse').val(token);
                });
            });
        }

        $(document).on('click', '.sidebar-cart__btn', function (event) {
            event.preventDefault();

            if (!$('#terms_and_conditions').is(":checked")) {
                toastr.error(acceptTermsAndConditions);
                return false;
            }

            let messageValue = $('textarea[name="message"]').val();
            messageValue = messageValue.replace('\n', '<br>');

            deliveryCity = $('select[name="cities"] option:selected').text()
            deliveryStreet = $('input[name="street"]').val();
            block = $('input[name="block"]').val();
            apartment = $('input[name="apartament"]').val();
            scara = $('input[name="scara"]').val();
            floor = $('input[name="floor"]').val();
            interphone = $('input[name="interphone"]').val();

            if (!$('.head-address-form-main-cart__item').hasClass('_active')) {
                toastr.error(pleaseSelectDeliveryMethod);
                return false;
            } else {

                let currentDeliveryTab = $('.head-address-form-main-cart__item._active').find('.head-address-form-main-cart__radio').val();

                if (currentDeliveryTab == '1' && deliveryCity == 'Selectați locația' || currentDeliveryTab == '1' && deliveryStreet == '' || currentDeliveryTab == '1' && block == '' || currentDeliveryTab == '1' && deliveryCity == 'Выберите локацию' || currentDeliveryTab == '1' && deliveryStreet == '' || currentDeliveryTab == '1' && block == '' || currentDeliveryTab == '1' && deliveryCity == 'Select location' || currentDeliveryTab == '1' && deliveryStreet == '' || currentDeliveryTab == '1' && block == '') {
                    $('input[name="name"]').addClass('error_input');
                    $('input[name="phone"]').addClass('error_input');
                    $('select[name="cities"]').next().addClass('error_input');
                    $('input[name="street"]').addClass('error_input');
                    $('input[name="block"]').addClass('error_input');
                    $('select[name="form"]').next().addClass('error_input');
                    toastr.error(fillNecesaryInfo);
                    return false;
                }

                if (deliveryCity != '' && deliveryCity != 'Selectați locația' && deliveryCity != 'Выберите локацию' && deliveryCity != 'Select location' || deliveryStreet != '' || block != '' || apartment != '' || scara != '' || floor != '' || interphone != '') {
                    fullAddress = '';

                    if (deliveryCity != '') {
                        fullAddress = fullAddress + ' ' + cityPlaceholder + ': ' + deliveryCity + '<br> ';
                    }

                    if (deliveryStreet != '') {
                        fullAddress = fullAddress + streetPlaceholder + ': ' + deliveryStreet + '<br> ';
                    }

                    if (block != '') {
                        fullAddress = fullAddress + blockPlaceholder + ': ' + block + '<br> ';
                    }

                    if (apartment != '') {
                        fullAddress = fullAddress + apartmentPlaceholder + ': ' + apartment + '<br> ';
                    }

                    if (scara != '') {
                        fullAddress = fullAddress + entrancePlaceholder + ': ' + scara + '<br> ';
                    }

                    if (floor != '') {
                        fullAddress = fullAddress + floorPlaceholder + ': ' + floor + '<br> ';
                    }

                    if (interphone != '') {
                        fullAddress = fullAddress + interphonePlaceholder + ': ' + interphone + '<br> ';
                    }
                } else {
                    fullAddress = '';
                    fullAddress = pickName + ' ' + pickAddress;
                }
            }

            if (fullAddress == '' || fullAddress == '   ') {
                $('input[name="name"]').addClass('error_input');
                $('input[name="phone"]').addClass('error_input');
                $('select[name="cities"]').next().addClass('error_input');
                $('input[name="street"]').addClass('error_input');
                $('input[name="block"]').addClass('error_input');
                $('select[name="form"]').next().addClass('error_input');
                toastr.error(fillNecesaryInfo);
                return false;
            }

            if (paymentMethod == '') {
                toastr.error(pleaseSelectPaymentMethod);
                return false;
            }

            if ($('input[name="name"]').val() == '' || $('input[name="phone"]').val() == '') {
                $('input[name="name"]').addClass('error_input');
                $('input[name="phone"]').addClass('error_input');
                toastr.error(fillNecesaryInfo);
                return false;
            }

            let restaurantId = $('select[name="form[]"]').val();

            $.ajax({
                type: 'POST',
                url: '/' + $('.language-main-header__item._active').attr('data-lang') + '/' + $('input[name="confirm_order_page"]').val(),
                data: {
                    name: $('input[name="name"]').val(),
                    phone: $('input[name="phone"]').val(),
                    email: $('input[name="mail"]').val(),
                    fullAddress: fullAddress,
                    message: messageValue,
                    restaurantId: restaurantId
                },
                success: function () {
                    window.location.href = '/' + $('.language-main-header__item._active').attr('data-lang') + '/' + $('input[name="confirm_order_page"]').val() + '?token=' + $('#recaptchaResponse').val() + '&name=' + $('input[name="name"]').val() + '&phone=' + $('input[name="phone"]').val() + '&mail=' + $('input[name="mail"]').val() + '&fullAddress=' + fullAddress + '&message=' + messageValue + '&restaurantId=' + restaurantId;
                }
            });
        });
    }

    if ($('.cart').length) {

        set_interval();

        if ($('.body-products-main-cart__item').length > 1) {
            $('.main-cart__more').removeAttr('style');
        } else {
            $('.main-cart__more').css('display', 'none');
        }

        $('.cart-main-header').css('pointer-events', 'none');

        if ($('#map').length) {

            // ymaps.ready(init);

            // function init() {
            //     myMap = new ymaps.Map('map', {
            //         center: [47.024512, 28.832157],
            //         zoom: 16
            //     }, {
            //         searchControlProvider: 'yandex#search'
            //     });
            // }
        }

        $(document).on('click', '.cities_option', function () {
            let deliveryP = $(this).attr('data-price');
            let remainP = $(this).attr('data-limit');

            $.ajax({
                type: "POST",
                url: "/update_delivery",
                data: {
                    deliveryPrice: deliveryP,
                    remainPrice: remainP
                },
                success: function (response) {
                    $('._delivery_value').find('.list-sidebar-cart__value').text(deliveryP.replace(',', '.') + ' mdl');
                    $('._delivery').find('.list-sidebar-cart__value').text(remainP.replace(',', '.') + ' mdl');
                    get_delivery_prices();
                }
            })
        });

        $(document).on('click', '.select_restaurant', function () {
            $.ajax({
                type: 'GET',
                url: '/get_shop_data',
                data: {
                    shopId: $(this).attr('data-value'),
                    lang: $('.language-main-header__item._active').attr('data-lang')
                },
                success: function (response) {
                    let shop = JSON.parse(response).shop;

                    $('.info-store-address-form-main-cart__name').text(shop.title);
                    $('.info-store-address-form-main-cart__address').text(shop.address);
                    $('.info-store-address-form-main-cart__time').text(shop.work_start + '-' + shop.work_end);
                    $('.info-store-address-form-main-cart__phone').text(shop.phone);
                    $('.info-store-address-form-main-cart__phone').attr('href', 'tel:' + shop.phone);

                    pickName = $('.info-store-address-form-main-cart__body').find('.info-store-address-form-main-cart__name').text();
                    pickAddress = $('.info-store-address-form-main-cart__body').find('.info-store-address-form-main-cart__address').text();
                    pickTime = $('.info-store-address-form-main-cart__body').find('.info-store-address-form-main-cart__time').text();
                    pickPhone = $('.info-store-address-form-main-cart__body').find('.info-store-address-form-main-cart__phone').text();

                    deliveryStreet = '';
                    block = '';
                    apartment = '';
                    scara = '';
                    floor = '';
                    interphone = '';

                    if (shop.lat != '' && shop.lat != null && shop.lng != '' && shop.lng != null) {
                        myMap.destroy();
                        myMap = null;

                        myMap = new ymaps.Map('map', {
                                center: [parseFloat(shop.lat), parseFloat(shop.lng)],
                                zoom: 17
                            }, {
                                searchControlProvider: 'yandex#search'
                            }),

                            MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
                                '<div style="color: #FFFFFF; font-weight: bold;">$[properties.iconContent]</div>'
                            ),

                            myPlacemark = new ymaps.Placemark(myMap.getCenter(), {
                                hintContent: ''
                            }, {
                                iconLayout: 'default#image',
                                iconImageSize: [38, 42],
                                iconImageOffset: [-5, -38]
                            });

                        myMap.geoObjects.add(myPlacemark);
                    }
                }
            });

        });

        $('input[name="address-delivery"]').on('click', function () {
            let deliveryType = $(this).val();

            $.ajax({
                type: 'POST',
                url: '/change_delivery_price',
                data: {
                    delivery_type: deliveryType
                },
                success: function () {
                    if (deliveryType == '2') {
                        pickName = $('.info-store-address-form-main-cart__body').find('.info-store-address-form-main-cart__name').text();
                        pickAddress = $('.info-store-address-form-main-cart__body').find('.info-store-address-form-main-cart__address').text();
                        pickTime = $('.info-store-address-form-main-cart__body').find('.info-store-address-form-main-cart__time').text();
                        pickPhone = $('.info-store-address-form-main-cart__body').find('.info-store-address-form-main-cart__phone').text();

                        deliveryStreet = '';
                        block = '';
                        apartment = '';
                        scara = '';
                        floor = '';
                        interphone = '';
                    } else {
                        pickName = '';
                        pickAddress = '';
                        pickTime = '';
                        pickPhone = '';
                    }
                }
            });

            if (deliveryType == '2') {
                $('.select_restaurant').each(function (index) {
                    if ($(this).hasClass('select__option')) {
                        $(this).trigger('click');
                        ajaxDelivery = '0,00';
                        ajaxDeliveryLimit = '0,00';
                        $('.head-address-form-main-cart__price').first().text('0.00 mdl');
                        $('._delivery').find('.list-sidebar-cart__value').text('0.00 mdl');
                        $('._delivery_value').find('.list-sidebar-cart__value').text('0.00 mdl');
                        $('._delivery').css('display', 'none');
                        $('._delivery_value').css('display', 'none');

                        return false;
                    }
                });
            } else {
                $('._delivery').removeAttr('style');
                $('._delivery_value').removeAttr('style');

                $('.cities_option').each(function (index) {
                    if ($(this).hasClass('select__option')) {
                        if ($(this).attr('data-value') == '0.00') {
                            $(this).trigger('click');
                        }
                    }
                });
            }
        });

        $('input[name="cart-pay"]').on('click', function () {
            let paymentType = $(this).val();
            $.ajax({
                type: 'POST',
                url: '/change_payment_type',
                data: {
                    paymentType: paymentType
                },
                success: function () {
                    paymentMethod = paymentType;
                }
            });
        });


        // calculate_cart_items_page();

        count_cart_items_placeholder();

        $(document).on('click', '.head-main-cart__clear', function () {
            $.ajax({
                type: 'POST',
                url: '/empty_cart',
                success: function (response) {
                    if (JSON.parse(response).success) {
                        $('.body-products-main-cart').remove();
                        update_cart();
                        calculate_cart_items_page();
                        location.reload();
                    } else {
                        update_cart();
                        calculate_cart_items_page();
                        toastr.error(basketIsEmpty);
                    }
                }
            });
        });
    }

    count_cart_items();

    if ($('.card').length) {

        let norPriceTopping = 0;
        let priceTopping = 0;
        let selectedNoPrice = [];
        let selectedCategory = [];

        $('._tabs-block').first().addClass('_active');

        showToppings($('.head-addition-card__item').first().attr('data-id'));

        $(document).on('click', '.head-addition-card__item', function () {
            showToppings($(this).attr('data-id'));
        });

        $(document).on('click', '.other-card__button', function (event) {
            if (norPriceTopping >= maxSauce && numberOfToppingsForCategory == '' && maxToppings == '' || norPriceTopping >= maxSauce && numberOfToppingsForCategory == '0' && maxToppings == '0') {
                event.preventDefault();
                $('.no-price-topping').each(function () {
                    if (!selectedNoPrice.includes($(this).find('.body-addition-card__input').val())) {
                        $(this).css('pointer-events', 'none');
                    }
                });
                return false;
            }

            if (priceTopping >= maxToppings && numberOfToppingsForCategory == '' && maxSauce == '' || priceTopping >= maxToppings && numberOfToppingsForCategory == '0' && maxSauce == '0') {
                event.preventDefault();

                $('.body-addition-card__price').parent().parent().parent().parent().each(function () {
                    if (!selectedNoPrice.includes($(this).find('.body-addition-card__input').val()) && !$(this).hasClass('hide_topping')) {
                        $(this).css('pointer-events', 'none');
                    }
                });

                $('.no-price-topping').each(function () {
                    if (!selectedNoPrice.includes($(this).find('.body-addition-card__input').val())) {
                        $(this).css('pointer-events', 'none');
                    }
                });
                return false;
            }

            if (norPriceTopping >= maxToppings && numberOfToppingsForCategory == '' && maxSauce == '' || norPriceTopping >= maxToppings && numberOfToppingsForCategory == '0' && maxSauce == '0') {
                event.preventDefault();

                $('.body-addition-card__price').parent().parent().parent().parent().each(function () {
                    if (!selectedNoPrice.includes($(this).find('.body-addition-card__input').val()) && !$(this).hasClass('hide_topping')) {
                        $(this).css('pointer-events', 'none');
                    }
                });

                $('.no-price-topping').each(function () {
                    if (!selectedNoPrice.includes($(this).find('.body-addition-card__input').val())) {
                        $(this).css('pointer-events', 'none');
                    }
                });
                return false;
            }
        });

        $(document).on('click', '.body-addition-card__item', function () {
            let quantityValue = $('.card__other').find('.quantity__input').find('input').val();
            let quantityPrice = $('.card__other').find('.quantity__input').find('input').attr('data-price');
            let currentValue = $(this).attr('data-price');

            if ($(this).find('.body-addition-card__input').is(":checked") == false && !$(this).hasClass('hide_topping')) {
                quantityPrice = parseFloat(quantityPrice) + parseFloat(currentValue);

                $('.card__other').find('.quantity__input').find('input').attr('data-price', quantityPrice);

                selectedCategory.push($(this).find('.body-addition-card__input').attr('data-category-id'));

                if ($(this).hasClass('no-price-topping') && !$(this).hasClass('hide_topping')) {
                    norPriceTopping = norPriceTopping + 1;

                    selectedNoPrice.push($(this).find('.body-addition-card__input').val());
                } else if (!$(this).hasClass('no-price-topping') && !$(this).hasClass('hide_topping')) {
                    priceTopping = priceTopping + 1;

                    selectedNoPrice.push($(this).find('.body-addition-card__input').val());
                }
            } else {
                quantityPrice = parseFloat(quantityPrice) - parseFloat(currentValue);
                $('.card__other').find('.quantity__input').find('input').attr('data-price', quantityPrice);

                let indexOfItem = selectedCategory.indexOf($(this).find('.body-addition-card__input').attr('data-category-id'));

                selectedCategory.splice(indexOfItem, 1);

                if ($(this).hasClass('no-price-topping') && !$(this).hasClass('hide_topping')) {
                    norPriceTopping = norPriceTopping - 1;

                    let index = selectedNoPrice.indexOf($(this).find('.body-addition-card__input').val());
                    if (index !== -1) {
                        selectedNoPrice.splice(index, 1);
                    }
                } else if (!$(this).hasClass('no-price-topping') && !$(this).hasClass('hide_topping')) {
                    priceTopping = priceTopping - 1;

                    let index = selectedNoPrice.indexOf($(this).find('.body-addition-card__input').val());
                    if (index !== -1) {
                        selectedNoPrice.splice(index, 1);
                    }
                }
            }

            // if (priceTopping == '0' && norPriceTopping == '0') {
            //     $('.body-addition-card__item').each(function () {
            //         $(this).removeAttr('style');
            //     });
            // }

            // if (maxToppings == '0') {
            //     $('.body-addition-card__item').each(function () {
            //         $(this).removeAttr('style');
            //     });
            // }

            if (priceTopping >= maxToppings && maxToppings > 0 && numberOfToppingsForCategory == '' || priceTopping >= maxToppings && maxToppings > 0 && numberOfToppingsForCategory == '0' || norPriceTopping >= maxToppings && maxToppings > 0 && numberOfToppingsForCategory == '' || norPriceTopping >= maxToppings && maxToppings > 0 && numberOfToppingsForCategory == '0') {
                $('.body-addition-card__price').parent().parent().parent().parent().each(function () {
                    if (!selectedNoPrice.includes($(this).find('.body-addition-card__input').val()) && !$(this).hasClass('hide_topping')) {
                        $(this).css('pointer-events', 'none');
                    }
                });

                $('.no-price-topping').each(function () {
                    if (!selectedNoPrice.includes($(this).find('.body-addition-card__input').val())) {
                        $(this).css('pointer-events', 'none');
                    }
                });
            } else if (priceTopping >= numberOfToppingsForCategory && numberOfToppingsForCategory != '' || priceTopping >= numberOfToppingsForCategory && numberOfToppingsForCategory != '0' || norPriceTopping >= numberOfToppingsForCategory && numberOfToppingsForCategory != '' || norPriceTopping >= numberOfToppingsForCategory && numberOfToppingsForCategory != '0') {
                let categoryCounter = 0;

                for (let i = 0; i < selectedCategory.length; i = i + 1) {
                    if (selectedCategory[i] == $('.head-addition-card__item._active').attr('data-id')) {
                        categoryCounter = categoryCounter + 1;
                    }
                }

                if (categoryCounter < numberOfToppingsForCategory) {
                    $('.body-addition-card__price').parent().parent().parent().parent().each(function () {
                        if (!selectedNoPrice.includes($(this).find('.body-addition-card__input').val()) && !$(this).hasClass('hide_topping')) {
                            $(this).removeAttr('style');
                        }
                    });
                } else {
                    $('.body-addition-card__price').parent().parent().parent().parent().each(function () {
                        if (!selectedNoPrice.includes($(this).find('.body-addition-card__input').val()) && !$(this).hasClass('hide_topping')) {
                            $(this).css('pointer-events', 'none');
                        }
                    });
                }
            } else if (norPriceTopping >= maxSauce && maxSauce > 0) {
                if (norPriceTopping == 0) {
                    $('.no-price-topping').each(function () {
                        if (!selectedNoPrice.includes($(this).find('.body-addition-card__input').val()) && !$(this).hasClass('hide_topping')) {
                            $(this).removeAttr('style');
                        }
                    });
                } else {
                    if (norPriceTopping >= maxSauce) {
                        $('.no-price-topping').each(function () {
                            if (!selectedNoPrice.includes($(this).find('.body-addition-card__input').val())) {
                                $(this).css('pointer-events', 'none');
                            }
                        });
                    }
                }
            } else {
                $('.no-price-topping').each(function () {
                    $(this).removeAttr('style');
                });
            }

            $('.other-card__button').text(add + ' ' + parseFloat(quantityPrice * quantityValue).toFixed(2) + ' mdl');
        });
    }

    $(document).on('click', '.main-banner__item, .mini-banner__item', function () {
        if ($(this).attr('data-href') != '') {
            window.open($(this).attr('data-href'), '_blank');
        }
    });

    $('.product-slider').each(function () {
        let odd_counter = 0,
            even_counter = 0;

        $(this).find('.product-slider__item').each(function () {
            if ($(this).attr('data-select-value') == '1') {
                odd_counter = odd_counter + 1;
            } else if ($(this).attr('data-select-value') == '2') {
                even_counter = even_counter + 1;
            }
        });

        if (odd_counter == '0' || even_counter == '0') {
            $(this).find('.head-product-slider__tabs').css('display', 'none');
        }
    });

    let icecreamBalls = {};

    $(document).on('click', '.quantity__button_plus', function () {
        currentValue = parseInt($(this).prev().find('input').val());
        currentValue = currentValue + 1;

        if ($('.icecreamballs_head').length > 0) {

            $('.icecreamballs_head').each(function () {
                let dataIdIce = $(this).attr('data-id');
                let dataValue = $(this).find('.other-card__quantity').find('.quantity').find('.quantity__input').find('input').val();

                if (dataValue != '0') {
                    icecreamBalls[dataIdIce] = dataValue;
                } else {
                    delete icecreamBalls[dataIdIce];
                }
            });

            let icecreamBallsCounter = 0;

            $('.icecreamballs_head').each(function () {
                let dataIdIce = $(this).attr('data-id');
                let dataValue = $(this).find('.other-card__quantity').find('.quantity').find('.quantity__input').find('input').val();

                if (dataValue != '0') {
                    icecreamBalls[dataIdIce] = dataValue;
                }

                icecreamBallsCounter = icecreamBallsCounter + parseInt(dataValue);
            });

            if (icecreamBallsCounter == icecreamballsNumber || icecreamBallsCounter > icecreamballsNumber) {
                return false;
            }

            $(this).prev().find('input').val(currentValue);
        } else {
            $(this).prev().find('input').val(currentValue);
        }
    });

    $(document).on('click', '.quantity__button_minus', function () {
        currentValue = parseInt($(this).next().find('input').val());
        if (currentValue > 1) {
            currentValue = currentValue - 1;
        }

        $(this).next().find('input').val(currentValue);
    });

    $(document).on('click', '.quantity__button_minus_icecream', function () {
        currentValue = parseInt($(this).next().find('input').val());
        if (currentValue > 0) {
            currentValue = currentValue - 1;
        }

        $(this).next().find('input').val(currentValue);

        if ($('.icecreamballs_head').length > 0) {
            $('.icecreamballs_head').each(function () {
                let dataIdIce = $(this).attr('data-id');
                let dataValue = $(this).find('.other-card__quantity').find('.quantity').find('.quantity__input').find('input').val();

                if (dataValue != '0') {
                    icecreamBalls[dataIdIce] = dataValue;
                } else {
                    delete icecreamBalls[dataIdIce];
                }
            });
        }
    });

    $(document).on('click', '.body-products-main-cart__delete', function () {
        delete_from_cart($(this));
    });

    $(document).on('click', '.quantity__button', function () {

        if ($(this).hasClass('quantity__button_plus_cart')) {
            let valueCart = $(this).prev().find('input').val();
            let productKey = $(this).prev().find('input').attr('data-key');

            update_product_amount(productKey, valueCart);
            update_header_cart();
        } else if ($(this).hasClass('quantity__button_plus')) {
            let value = $(this).prev().find('input').val();
            let dataPrice = parseFloat($(this).prev().find('input').attr('data-price'));
            let productKey = $(this).prev().find('input').attr('data-key');

            update_product_amount(productKey, value);
            count_cart_items_placeholder();
            update_cart();

            if ($('.card').length) {
                $(this).parent().parent().next().text(add + ' ' + parseFloat(dataPrice * value).toFixed(2) + ' mdl');
            } else {
                $(this).parent().parent().next().text(parseFloat(dataPrice * value).toFixed(2) + ' mdl');
            }

            calculate_cart_items_page();
        }

        if ($(this).hasClass('quantity__button_minus_cart')) {
            let valueCart = $(this).next().find('input').val();
            let productKey = $(this).next().find('input').attr('data-key');

            update_product_amount(productKey, valueCart);
            update_header_cart();
        } else if ($(this).hasClass('quantity__button_minus')) {
            let value = $(this).next().find('input').val();
            let dataPrice = parseFloat($(this).next().find('input').attr('data-price'));
            let productKey = $(this).next().find('input').attr('data-key');

            update_product_amount(productKey, value);
            count_cart_items_placeholder();
            update_cart();

            $(this).next().find('input').val(value);

            if ($('.card').length) {
                $(this).parent().parent().next().text(add + ' ' + parseFloat(dataPrice * value).toFixed(2) + ' mdl');
            } else {
                $(this).parent().parent().next().text(parseFloat(dataPrice * value).toFixed(2) + ' mdl');
            }

            calculate_cart_items_page();
        }
    });

    $(document).on('click', '.products-cart-main-header__delete', function () {
        if (confirm(confirmProductDelete)) {
            $(this).parent().parent().parent().remove();

            $.ajax({
                type: 'POST',
                url: '/delete_from_cart',
                data: {
                    productId: $(this).attr('data-id')
                },
                success: function (response) {
                    count_cart_items();
                    update_header_cart();
                    toastr.success(productRemovedFromCart);
                }
            });
        }
    });

    let toppings = [];

    $(document).on('click', '.body-addition-card__item', function (event) {
        event.preventDefault();
        if (jQuery.inArray($(this).find('.body-addition-card__input').val(), toppings) != -1) {
            toppings = toppings.filter(item => item !== $(this).find('.body-addition-card__input').val());
            $(this).find('input').removeAttr('checked');
        } else {
            toppings.push($(this).find('.body-addition-card__input').val());
            $(this).find('input').attr('checked', 'checked');
        }
    });

    $('.other-card__button').on('click', function () {

        console.log(maxSauce);

        let countFreeToppings = 0,
            countNumberOfToppingsForCategory = 0,
            countNumberOfToppings = 0;

        if (numberOfToppingsForCategory != '' && numberOfToppingsForCategory != '0') {
            $('.body-addition-card__input').each(function () {
                if ($(this).is(":checked")) {
                    countNumberOfToppingsForCategory = countNumberOfToppingsForCategory + 1;
                }
            });

            if (countNumberOfToppingsForCategory < numberOfToppingsForCategory) {
                alert(selectLable + ' ' + numberOfToppingsForCategory + ' ' + toppingsOfEachCategory);
                return false;
            }
        }

        if ($('.no-price-topping').length > 0) {
            $('.no-price-topping').each(function () {
                if ($(this).find('.body-addition-card__input').is(":checked")) {
                    countFreeToppings = countFreeToppings + 1;
                }
            });

            if (countFreeToppings == 0) {
                alert(selectOneFreeTopping);
                return false;
            }

            if (countFreeToppings < maxSauce) {
                alert(selectLable + ' ' + maxSauce + ' ' + freeToppingsLable);
                return false;
            }
        }

        let price = $(this).prev().find('.quantity__input').find('input').attr('data-price');
        let icecreamBalls = {};
        let icecreamBallsCounter = 0;

        $('.icecreamballs_head').each(function () {
            let dataIdIce = $(this).attr('data-id');
            let dataValue = $(this).find('.other-card__quantity').find('.quantity').find('.quantity__input').find('input').val();

            if (dataValue != '0') {
                icecreamBalls[dataIdIce] = dataValue;
            }

            icecreamBallsCounter = icecreamBallsCounter + parseInt(dataValue);
        });

        if (icecreamBallsCounter < icecreamballsNumber || icecreamBallsCounter > icecreamballsNumber) {
            alert(requiredBalls + ": " + icecreamballsNumber);
            return false;
        }

        if (maxToppings != '' && maxToppings != '0' && numberOfToppingsForCategory == '' || maxToppings != '' && maxToppings != '0' && numberOfToppingsForCategory == '0') {
            $('.body-addition-card__input').each(function () {
                if ($(this).is(":checked")) {
                    countNumberOfToppings = countNumberOfToppings + 1;
                }
            });

            if (countNumberOfToppings < maxToppings) {
                alert(selectLable + ' ' + maxToppings + ' ' + toppingsLabel);
                return false;
            }
        }

        $.ajax({
            type: 'POST',
            url: '/add_to_cart',
            data: {
                productId: $(this).attr('data-id'),
                amount: $(this).prev().find('.quantity__input').find('input').val(),
                toppings: toppings,
                icecreamBalls: icecreamBalls
            },
            success: function () {
                count_cart_items();
                update_cart();

                $('.head-addition-card__item').first().trigger('click');
                $('.quantity__input input').val(1);
                $('.quantity__input_icecream input').val(0);
                $('.other-card__button').text(add + ' ' + parseFloat(price * 1).toFixed(2) + ' mdl');
                $('.body-addition-card__item').find('input').each(function () {
                    $(this).removeAttr('checked');
                });

                $('.body-addition-card__item').each(function () {
                    $(this).find('input').removeAttr('checked');
                });

                toppings = [];

                toastr.success(productAddedToCart);

                setTimeout(() => {
                    location.reload();
                }, 1000);
            }
        });

        $('.body-addition-card__item').each(function () {
            $(this).removeAttr('style');
        });
    });

    $(document).on('click', '.cart-product', function () {
        let currentObject = $(this);
        $.ajax({
            type: 'POST',
            url: '/add_to_cart',
            data: {
                productId: currentObject.attr('data-id'),
                amount: '1'
            },
            success: function () {
                count_cart_items();
                update_cart();

                toastr.success(productAddedToCart);
                currentObject.parent().parent().parent().addClass('_liked');
            }
        });
    });
});